import {
  ADD_PRODUCT,
  ADD_PRODUCT_ERROR,
  ADD_PRODUCT_START,
  CLEAR_ERROR_PRODUCT,
  DELETE_PRODUCT,
  DELETE_PRODUCT_ERROR,
  DELETE_PRODUCT_START,
  GET_PRODUCT,
  GET_PRODUCT_ERROR,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_ERROR,
  GET_PRODUCT_LIST_PAGEABLE,
  GET_PRODUCT_LIST_PAGEABLE_ERROR,
  GET_PRODUCT_LIST_PAGEABLE_START,
  GET_PRODUCT_LIST_START,
  GET_PRODUCT_START,
  GET_PRODUCT_WITH_LOGO,
  GET_PRODUCT_WITH_LOGO_ERROR,
  GET_PRODUCT_WITH_LOGO_START,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_ERROR,
  UPDATE_PRODUCT_START,
} from '../actions/types';

const initialState = {
  productList: [],
  product: {},
  productWithLogo: {},
  loading: false,
  logoLoading: false,
  error: undefined,
  totalElements: '',
};

//ADD
const addProductStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addProduct = (state, action) => {
  return {
    ...state,
    loading: false,
    productList: state.productList.concat(action.payload),
  };
};

const addProductError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

//UPDATE
const updateProductStart = (state) => {
  return {
    ...state,
  };
};

const updateProduct = (state, action) => {
    return {
        ...state,
        productList: state.productList.map((product) =>
            product.id === action.payload.id ?
                action.payload : product
        ),
        product: action.payload, 
        productWithLogo: state.productWithLogo.id === action.payload.id 
            ? { ...state.productWithLogo, ...action.payload } 
            : state.productWithLogo, 
        loading: false,
    };
};

const updateProductError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

//FIND ALL

const findAllProductsStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllProducts = (state, ation) => {
  return {
    ...state,
    productList: action.payload,
    loading: false,
  };
};

const findAllProductsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

//FIND BY ID

const findProductByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findProductById = (state, action) => {
  return {
    ...state,
    product: action.payload,
    loading: false,
  };
};

const findProductByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

//FIND BY ID WITH LOGO
const findProductByIdWithLogoStart = (state) => {
  return {
    ...state,
    logoLoading: true,
  };
};

const findProductByIdWithLogo = (state, action) => {
  return {
    ...state,
    productWithLogo: action.payload,
    logoLoading: false,
  };
};

const findProductByIdWithLogoError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    logoLoading: false,
  };
};

//DELETE

const deleteProductStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteProduct = (state, action) => {
  return {
    ...state,
    productList: state.productList.filter(
      (product) => product.id !== action.payload
    ),
  };
};

const deleteProductError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

//PAGEABLE

const findAllProductsPageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllProductsPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllProductsPageable = (state, action) => {
  return {
    ...state,
    productList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    //productList: [...action.payload.list],
    //totalElements: action.payload.totalElements,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_PRODUCT:
      return addProduct(state, action);
    case ADD_PRODUCT_START:
      return addProductStart(state);
    case ADD_PRODUCT_ERROR:
      return addProductError(state, action);

    case UPDATE_PRODUCT_START:
      return updateProductStart(state);
    case UPDATE_PRODUCT:
      return updateProduct(state, action);
    case UPDATE_PRODUCT_ERROR:
      return updateProductError(state, action);

    case GET_PRODUCT_LIST_START:
      return findAllProductsStart(state);
    case GET_PRODUCT_LIST:
      return findAllProducts(state, action);
    case GET_PRODUCT_LIST_ERROR:
      return findAllProductsError(state, action);

    case GET_PRODUCT_START:
      return findProductByIdStart(state);
    case GET_PRODUCT:
      return findProductById(state, action);
    case GET_PRODUCT_ERROR:
      return findProductByIdError(state, action);

    case GET_PRODUCT_WITH_LOGO_START:
      return findProductByIdWithLogoStart(state);
    case GET_PRODUCT_WITH_LOGO:
      return findProductByIdWithLogo(state, action);
    case GET_PRODUCT_WITH_LOGO_ERROR:
      return findProductByIdWithLogoError(state, action);

    case DELETE_PRODUCT_START:
      return deleteProductStart(state);
    case DELETE_PRODUCT:
      return deleteProduct(state, action);
    case DELETE_PRODUCT_ERROR:
      return deleteProductError(state, action);
    case CLEAR_ERROR_PRODUCT:
      return clearError(state);

    case GET_PRODUCT_LIST_PAGEABLE_START:
      return findAllProductsPageableStart(state);
    case GET_PRODUCT_LIST_PAGEABLE:
      return findAllProductsPageable(state, action);
    case GET_PRODUCT_LIST_PAGEABLE_ERROR:
      return findAllProductsPageableError(state, action);

    default:
      return state;
  }
}
